export default __webpack_public_path__ + "static/media/question_mark2.00de4fc7.gif";